import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import DeleteHook from "../../Hooks/DeleteHook";
import ResellerEditProfileModal from "./SuperAdminModal/ResellerEditProfileModal";
import { PiUserSwitchLight } from "react-icons/pi";
import SwitchRefModal from "./SwitchRefModal";
import { Link } from "react-router-dom";

const SuperAdminAllPatientTable = ({ resellerData, refetch, setRefetch }) => {
  const [selectedResellerData, setSelectedResellerData] = useState(null);
  const [modalIsOpenResellerEditProfile, setModalIsOpenResellerEditProfile] =
    useState(false);
  const [isOpenSwitchRef, setIsOpenSwitchRef] = useState(false);

  const openModalResellerEditProfile = (reseller) => {
    setSelectedResellerData(reseller);
    setModalIsOpenResellerEditProfile(true);
  };

  const closeModalResellerEditProfile = () => {
    setModalIsOpenResellerEditProfile(false);
  };

  const openSwitchRefModal = (reseller) => {
    setSelectedResellerData(reseller);
    setIsOpenSwitchRef(true);
  };

  const closeSwitchRefModal = () => {
    setIsOpenSwitchRef(false);
  };

  return (
    <tr className="hover:bg-slate-50/50 transition-colors">
      <td className="px-6 py-4 text-xs font-bold text-slate-800">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-emerald-50 text-emerald-700 font-extrabold flex items-center justify-center">
            {(resellerData.name || "P").substring(0, 1).toUpperCase()}
          </div>
          <span className="whitespace-nowrap">{resellerData.name}</span>
        </div>
      </td>
      <td className="px-6 py-4 text-xs font-medium text-slate-500">
        {resellerData.email}
      </td>
      <td className="px-6 py-4 text-xs font-medium text-slate-500">
        {resellerData.phone || "N/A"}
      </td>
      <td className="px-6 py-4 text-xs font-semibold text-slate-600">
        {resellerData.referralName ? (
          <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-md text-[10px] tracking-wide border border-indigo-100 whitespace-nowrap">
            {resellerData.referralName}
          </span>
        ) : (
          <span className="text-slate-400 font-light">N/A</span>
        )}
      </td>
      <td className="px-6 py-4 text-xs">
        <span className="bg-slate-50 text-slate-600 font-bold px-2.5 py-0.5 rounded-full text-[10px] tracking-wide uppercase border border-slate-200">
          Patient
        </span>
      </td>
      <td className="px-6 py-4 text-xs">
        <span
          className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide border ${resellerData?.isActive
            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
            : "bg-rose-50 text-rose-700 border-rose-100"
            }`}
        >
          <span className={`w-1.5 h-1.5 rounded-full ${resellerData?.isActive ? "bg-emerald-500" : "bg-rose-500"}`} />
          {resellerData?.isActive ? "Active" : "Inactive"}
        </span>
      </td>
      <td className="px-6 py-4 text-xs">
        <div className="flex justify-end items-center gap-2">
          <Link to={`/superAdminDashboard/superadmin-doctor-patient-report/${resellerData?._id}`} className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 border border-slate-200 hover:border-indigo-150 rounded-lg transition-all cursor-pointer">
            <Icon icon="solar:graph-bold" className="w-4 h-4" /></Link>
          <button
            onClick={() => openSwitchRefModal(resellerData)}
            className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 border border-slate-200 hover:border-indigo-150 rounded-lg transition-all cursor-pointer"
            title="Switch Referral Doctor"
          >
            <PiUserSwitchLight className="w-4 h-4" />
          </button>

          <button
            onClick={() => openModalResellerEditProfile(resellerData)}
            className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 border border-slate-200 hover:border-indigo-150 rounded-lg transition-all cursor-pointer"
            title="Edit profile details"
          >
            <Icon icon="basil:edit-outline" className="w-4 h-4" />
          </button>

          <button
            aria-label="Open delete confirmation"
            onClick={(e) => {
              DeleteHook({
                refetch,
                setRefetch,
                url: `https://servercareseebd.careseebd.com/api/v1/user/${resellerData?._id}`,
              });
            }}
            className="p-1.5 text-slate-400 hover:text-rose-600 hover:bg-rose-50 border border-slate-200 hover:border-rose-150 rounded-lg transition-all cursor-pointer"
            title="Delete patient"
          >
            <Icon icon="material-symbols:delete-outline" className="w-4 h-4" />
          </button>
        </div>
      </td>

      <ResellerEditProfileModal
        resellerData={selectedResellerData}
        isOpen={modalIsOpenResellerEditProfile}
        closeModal={closeModalResellerEditProfile}
      />
      <SwitchRefModal
        resellerData={selectedResellerData}
        isOpen={isOpenSwitchRef}
        closeModal={closeSwitchRefModal}
      />
    </tr>
  );
};

export default SuperAdminAllPatientTable;
